import { NetworkService } from "./network-service";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

const handleElaborationError = (endpoint, error)=>{
    console.error(`Errore durante l'operazione su ${endpoint}: `, error);
}

export const ElaborationService = {

    createElaboration: (body,callback,errorCallback)=>{
        const url = `${API_BASE_URL}/api/elaborations/create-elaboration/`;
        NetworkService.post(url, body,callback, (error)=>{
            handleElaborationError('Creazione elaborazione', error);
            if(errorCallback){
                errorCallback(error)
            }
        })
    },

    startSingleElaboration: (elabId,body,callback,errorCallback)=>{
        const url = `${API_BASE_URL}/api/elaborations/${elabId}/process-files/`;
        NetworkService.post(url, body,callback, (error)=>{
            handleElaborationError('avvio singola elaborazione', error);
            if(errorCallback){
                errorCallback(error)
            }
        })
    },

    getAllElaborations:(callback,errorCallback)=>{
        const url = `${API_BASE_URL}/api/elaborations/`;
        NetworkService.get(url,(data)=>{
            callback(data)
        }, (error)=>{
            handleElaborationError("elenco delle elaborazioni", error)
            if(errorCallback){
                errorCallback(error)
            }
        })
    },

    deleteElaboration:(elaborationId, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/elaborations/${elaborationId}/`;
        NetworkService.delete(url,callback, (error)=>{
            handleElaborationError(`eliminazione dell'elaborazione con ID ${elaborationId}`, error);
            if(errorCallback){
                errorCallback(error)
            }
        })
    },

    getSingleElaboration:(elaborationId,callback,errorCallback)=>{
        const url = `${API_BASE_URL}/api/elaborations/${elaborationId}/status/`;
        NetworkService.get(url,(data)=>{
            callback(data);
        },(error)=>{
            handleElaborationError("elenco delle elaborazioni", error)
            if(errorCallback){
                errorCallback(error)
            }
        })
    },

    fetchMarkdownContent: (downloadUrl, token, setMarkdownContent) => {
        fetch(downloadUrl, {
        headers: {
            Authorization: `Token ${token}`,
        },
        })
        .then((response) => {
            if (!response.ok) {
            throw new Error(
                `Errore nel recupero del file md: ${response.status}`
            );
            }
            return response.text();
        })
        .then((text) => {
            setMarkdownContent(text);
        })
        .catch((error) => {
            console.error('Errore durante il recupero del file md:', error);
        });
  },
}